import { gql } from 'graphql-request';

export const POA_REVOKE = gql`
  mutation PoaRevoke($id: ID!, $signature: String!, $detachedSignature: String) {
    corePOA {
      revoke(id: $id, signature: $signature, detachedSignature: $detachedSignature)
    }
  }
`;
